export default __webpack_public_path__ + "static/around1-9740a0811e433cc912fcac62c7e7ad77.png";